import { RoleType } from 'api-validations/user-api'
import { useEffect, useState } from 'react'

import { readLocalStorageItem, removeLocalStorageItem, useLocalStorage } from '../../hooks'
import { DEMO_ORG_CODE, useAccount } from './useAccount'
import { useOrgInfo } from './useOrgInfo'

const RECENT_ORG_CODES_KEY = 'recentOrgCodes'
const LAST_VISITED_ORG_CODE_KEY = 'lastVisitedOrgCode'
const MAX_RECENT_ORG_CODES = 20

export const useRecentOrgCodes = () => {
  const orgInfo = useOrgInfo()
  const account = useAccount()
  const [initialRecentOrgCodes] = useState(() => {
    const lastVisitedOrgCode = readLocalStorageItem<string | null>(LAST_VISITED_ORG_CODE_KEY, null)
    return lastVisitedOrgCode === null ? [] : [lastVisitedOrgCode]
  })
  const [recentOrgCodes, setRecentOrgCodes] = useLocalStorage({
    key: RECENT_ORG_CODES_KEY,
    defaultValue: initialRecentOrgCodes
  })
  const canRememberOrg =
    orgInfo !== undefined &&
    orgInfo.userRoleType !== RoleType.Supporter &&
    orgInfo.orgCode !== DEMO_ORG_CODE
  const orgCode = canRememberOrg ? orgInfo.orgCode : undefined

  useEffect(() => {
    if (orgCode === undefined) return

    const previousOrgCodes = readLocalStorageItem(RECENT_ORG_CODES_KEY, initialRecentOrgCodes)
    setRecentOrgCodes(
      [orgCode, ...previousOrgCodes.filter((previousOrgCode) => previousOrgCode !== orgCode)].slice(
        0,
        MAX_RECENT_ORG_CODES
      )
    )
    removeLocalStorageItem(LAST_VISITED_ORG_CODE_KEY)
  }, [initialRecentOrgCodes, orgCode, setRecentOrgCodes])

  return recentOrgCodes.filter(
    (recentOrgCode) =>
      account.data?.orgMemberships.some(({ orgCode }) => orgCode === recentOrgCode) ?? false
  )
}
